import { useGraphQLMutation } from '@opengov/bnp-core';
import { graphql } from '../../../../../gql-generated/hasura';
import { HASURA_SERVICE_URL } from '../../../../../config/config';
import { customReportsQueryKeys } from './customReportsQueryKeys';

const UpdateSpreadsheetForUploadedFileMutation = graphql(`
  mutation UpdateSpreadsheetForUploadedFile(
    $id: uuid!
    $name: String!
    $processingStatus: spreadsheetsProcessingStatus_enum!
  ) {
    update_spreadsheets_by_pk(
      pk_columns: { id: $id }
      _set: { name: $name, processingStatus: $processingStatus, updatedAt: "now()" }
    ) {
      id
      name
      processingStatus
    }
  }
`);

export function useUpdateSpreadsheetForUploadedFile() {
  return useGraphQLMutation({
    mutationKey: customReportsQueryKeys.updateSpreadsheet(),
    document: UpdateSpreadsheetForUploadedFileMutation,
    url: HASURA_SERVICE_URL
  });
}
